import React from 'react';
import { IHTCalculation } from '../../types';

interface Props {
    ihtCalc?: IHTCalculation | null;
}

/**
 * WP1 — a declared (or explicitly uncertain) trust may hold property that belongs in the estate and is not included.
 * Shown beside the figures wherever the report body is rendered, so the provisional framing and the specialist-review
 * recommendation travel with the tax figure. The text is the engine's own 'trust_estate_inclusion' note.
 */
export const TrustEstateInclusionNotice: React.FC<Props> = ({ ihtCalc }) => {
    if (!ihtCalc?.breakdown?.trust_estate_inclusion_gap) return null;
    const notes = (ihtCalc.confidence?.flags ?? []).filter((f) => f.field === 'trust_estate_inclusion').map((f) => f.note);

    return (
        <div data-testid="trust-estate-inclusion-notice" role="note" className="bg-white border border-[#1A1A1A] rounded overflow-hidden">
            <div className="px-6 py-4 border-b border-[#1A1A1A]">
                <h2 className="font-serif text-[22px] font-normal tracking-[-0.01em] text-[#1A1A1A] m-0">
                    Specialist IHT advice recommended
                </h2>
                <p className="text-[13px] font-serif italic text-[#3F3D39] mt-1">
                    Trust property may be missing from this calculation. The figures shown are provisional, not a final tax amount.
                </p>
            </div>
            <div className="p-6 space-y-2">
                {notes.map((note, i) => (
                    <p key={i} className="text-[13px] text-[#3F3D39] leading-relaxed m-0">{note}</p>
                ))}
            </div>
        </div>
    );
};
